import React from "react";
import { FD_DECLINE_THANKS } from "../copy.js";
import { ReadableNavButton } from "../../../components/Sticker";
import { FieldHint } from "../../../components/createEvent/CreateEventFormUi";

export default function DeclineStep({
  onClose,
  closeTestId = "favorite-dances-decline-done",
  closeLabel = "Back to event",
}) {
  return (
    <div className="space-y-5 text-center py-4" data-testid="favorite-dances-declined">
      <p className="font-ui font-semibold text-[16px] leading-snug text-ink text-pretty text-balance">Thanks for letting us know</p>
      <FieldHint className="text-[14px] text-ink/75 text-pretty">{FD_DECLINE_THANKS}</FieldHint>
      <ReadableNavButton
        type="button"
        variant="primary"
        className="w-full py-3.5 text-[15px]"
        onClick={onClose}
        data-testid={closeTestId}
      >
        {closeLabel}
      </ReadableNavButton>
    </div>
  );
}
